import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { calculateAverages } from '../utils/calc';

import { List } from 'material-ui/List';
import { ResponsiveRadar } from '@nivo/radar';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import {
    clearProposal,
    getProposal,
} from '../actions/proposalAction';

import changes from '../constants/changes.json';
import financing from '../constants/financing.json';
import program from '../constants/program.json';
import status from '../constants/status.json';

moment.locale('nb');

const changeMap = changes.reduce((m, o) => {
    m[o.key] = o.text;
    return m;
}, {});

const financingMap = financing.reduce((m, o) => {
    m[o.key] = o.text;
    return m;
}, {});

const programMap = program.reduce((m, o) => {
    m[o.key] = o.text;
    return m;
}, {});

const statusMap = status.reduce((m, o) => {
    m[o.key] = o.text;
    return m;
}, {});

function FieldItem(props) {
    const { label, value, onClick } = props;
    const styles = {
        wrap: {
            marginLeft: 16,
        },
        label: {
            lineHeight: 1.8,
            margin: "10px 0 0",
            color: "rgba(0,0,0, .54)",
            fontSize: 14,
        },
        value: {
            lineHeight: 1.4,
            fontSize: 15,
        },
    };
    return (
        <div style={styles.wrap}>
            <div style={styles.label}>{label}</div>
            <div
                style={styles.value}
                onClick={onClick || null}
            >
                {value}
            </div>
        </div>
    );
}
FieldItem.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onClick: PropTypes.func,
};

class ViewProposalPage extends React.Component {
    static propTypes = {
        router: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        params: PropTypes.object.isRequired,
        proposal: PropTypes.object.isRequired,
    }

    state = {
        proposal: {
            GeneralData: {},
        },
    }

    componentDidMount() {
        const { dispatch, params } = this.props;
        dispatch(clearProposal());
        dispatch(getProposal(params.Id));
    }

    componentWillReceiveProps(nextProps) {
        const proposal = {...nextProps.proposal,
            GeneralData: {...nextProps.proposal.GeneralData},
        };
        calculateAverages(proposal);
        this.setState({proposal});
    }

    render() {
        const { proposal } = this.state;
        const data = [
            {
                "name": "Totalt",
                "forslag": parseFloat(proposal.AverageScore) || 0,
            },
            {
                "name": "Strategi",
                "forslag": parseFloat(proposal.StrategyAverage) || 0,
            },
            {
                "name": "Nytte",
                "forslag": parseFloat(proposal.BenefitAverage) || 0,
            },
            {
                "name": "Omfang",
                "forslag": parseFloat(proposal.ScopeAverage) || 0,
            },
            {
                "name": "Risiko",
                "forslag": parseFloat(proposal.RiskAverage) || 0,
            },
            {
                "name": "Fast-Track",
                "forslag": parseFloat(proposal.FastTrack) || 0,
            },
            {
                "name": "Pålagt",
                "forslag": parseFloat(proposal.Required1) || 0,
            },
        ];

        return (
            <section style={{
                width: 600,
                margin: '0 auto',
            }}>
                <h1>{proposal.GeneralData.Title}</h1>

                <List>
                    <Subheader>Generell informasjon</Subheader>
                    <Divider/>
                    <FieldItem
                        label="Kort beskrivelse av behov"
                        value={proposal.GeneralData.DescriptionOfNeed || '-'}
                    />
                    <FieldItem
                        label="Nytteverdi"
                        value={proposal.GeneralData.Benefit || '-'}
                    />
                    <FieldItem
                        label="Omfang"
                        value={proposal.GeneralData.Scope || '-'}
                    />
                    <FieldItem
                        label="Strategisk"
                        value={proposal.GeneralData.Strategic || '-'}
                    />
                    <FieldItem
                        label="Kontaktperson virksomhet/kunde"
                        value={proposal.GeneralData.ClientContact && proposal.GeneralData.ClientContact.text || '-'}
                    />
                    <FieldItem
                        label="Kontaktperson IT"
                        value={proposal.GeneralData.ItContact && proposal.GeneralData.ItContact.text || '-'}
                    />
                    <FieldItem
                        label="Hovedeier/forvalter av tjenesten"
                        value={proposal.GeneralData.MainAdmin || '-'}
                    />
                    <FieldItem
                        label="Hovedbruker av tjenesten"
                        value={proposal.GeneralData.MainUser || '-'}
                    />

                    <div style={{margin: '0 auto', width: 450, height: 450}}>
                        <ResponsiveRadar
                            keys={[ "forslag" ]}
                            indexBy="name"
                            data={data}
                            width={450}
                            height={450}
                            gridShape="linear"
                            enableDots={true}
                            dotSize={8}
                            dotColor="inherit"
                            dotBorderWidth={0}
                            dotBorderColor="#ffffff"
                            enableDotLabel={true}
                            dotLabel="value"
                            dotLabelYOffset={-12}
                            fillOpacity={0.1}
                            margin={{
                                top: 20,
                                right: 40,
                                bottom: 20,
                                left: 80,
                            }}
                        />
                    </div>

                    <Subheader>Behandling</Subheader>
                    <Divider/>
                    <FieldItem
                        label="Fora behandlet"
                        value={proposal.ProcessedForum || '-'}
                    />
                    <FieldItem
                        label="Dato behandlet"
                        value={moment(proposal.ProcessedDate, 'DD/MM/YYYY').format('ll')}
                    />
                    <FieldItem
                        label="Status"
                        value={proposal.Status1}
                    />
                    <FieldItem
                        label="Oppsummering av behandling"
                        value={proposal.ProcessedSummary || '-'}
                    />
                    <FieldItem
                        label="Finansiering"
                        value={proposal.Financing1}
                    />
                    <FieldItem
                        label="Endringsportefølje"
                        value={proposal.ChangePortfolio}
                    />
                    <FieldItem
                        label="Forvaltningsområde"
                        value={proposal.AdminArea || '-'}
                    />
                    <FieldItem
                        label="Ansvarlig for oppfølging"
                        value={proposal.Responsible && proposal.Responsible.text || '-'}
                    />
                    <FieldItem
                        label="URL til prosjektrom"
                        value={proposal.ProjectRoom || '-'}
                        onClick={() => proposal.ProjectRoom && window.open(proposal.ProjectRoom, '_blank')}
                    />
                    <FieldItem
                        label="Forslag oppstart"
                        value={moment(proposal.ProposedStart, 'DD/MM/YYYY').format('ll') || '-'}
                    />
                    <FieldItem
                        label="Prosjektportefølje nr"
                        value={proposal.PortfolioNr || '-'}
                    />
                </List>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        proposal: state.proposalData.proposal,
    };
}

export default connect(mapStateToProps)(ViewProposalPage);



// WEBPACK FOOTER //
// ./src/containers/ViewProposalPage.js